<!-- Sidebar -->
<div class="hidden lg:flex items-center justify-center shrink-0 pt-8 pb-3.5" id="sidebar_header">
	<a href="#">
		<img class="dark:hidden min-h-[42px]" src="assets/media/app/mini-logo-square-gray.svg">
		<img class="hidden dark:block min-h-[42px]" src="assets/media/app/mini-logo-square-gray-dark.svg">
	</a>
</div>
<div class="kt-scrollable-y-hover grow gap-2.5 shrink-0 flex items-center pt-5 lg:pt-0 ps-3 pe-3 lg:pe-0 flex-col"
	data-kt-scrollable="true" data-kt-scrollable-dependencies="#sidebar_header,#sidebar_footer"
	data-kt-scrollable-height="auto" data-kt-scrollable-offset="80px"
	data-kt-scrollable-wrappers="#sidebar_menu_wrapper" id="sidebar_menu_wrapper" data-kt-scrollable-initialized="true"
	style="height: 940px;">

	<app-sidebar-menu></app-sidebar-menu>
</div>
<app-sidebar-footer></app-sidebar-footer>
<!-- End of Sidebar -->